import _ from "@lodash";
import XAPPService from "app/Core/services/XAPPService";
export const GET_DOCUMENTOATENDIMENTO = "[DOCUMENTOATENDIMENTO] GET DOCUMENTOATENDIMENTO";
export const CHECK_TOKEN = "[DOCUMENTOATENDIMENTO] CHECK TOKEN";
export const DOCUMENTOATENDIMENTO_ERROR = "[DOCUMENTOATENDIMENTO] DOCUMENTOATENDIMENTO ERROR";

export function get(_ATipo, _AProps) {

    let AString = "";
    AString += "/documentos/documentoatendimento/" + _ATipo;
    AString += "?usuario=" + window.sessionStorage.getItem("username");
    AString += "&funcionalidade=" + _AProps.idfuncionalidade;
    AString += "&pessoaformulario=" + _AProps.idpessoaformulario;
    AString += "&agendamentopessoaformulario=" + _AProps.idagendamentopessoaformulario;
    AString += "&empresa=" + _AProps.xappRouteParams.empresa;
    AString += "&theme=" + window.sessionStorage.getItem("theme").replace("#", "");
    AString += "&themetype=" + window.sessionStorage.getItem("themetype");
    AString += "&canprintheader=" + _AProps.canPrintHeader;
    AString += "&canprintfooter=" + _AProps.canPrintFooter;
    AString += "&status=" + _AProps.status;
    AString += "&segmento=" + window.sessionStorage.getItem("tipo-sistema");
    AString += "&readonly=" + (_AProps.readOnly ? "1" : "0");

    if (!_.isUndefined(_AProps.convenio)) {
        AString += "&convenio=" + _AProps.convenio;
    }

    return (dispatch) => {
        XAPPService.getDocumentoAtendimento(AString)
            .then((response) => {
                Promise.all([
                    dispatch({
                        type: GET_DOCUMENTOATENDIMENTO,
                        payload: response
                    })
                ]);
            }).catch(error => {
                return dispatch({
                    type: DOCUMENTOATENDIMENTO_ERROR,
                    payload: error
                });
            });
    };
}

export function checkToken(_AParams) {

    return (dispatch) => {
        var AConditionsAND = [{ "Campo": "id", "Operador": "=", "Valor": "4210506" }];
        var AConditionsOR = [];
        var AActions = [];

        AActions = XAPPService.XappLookupActionFactory("Cidade", AActions, AConditionsAND, AConditionsOR);

        XAPPService.XappLookupAction(AActions, _AParams)
            .then((response) => {
                if (!_.isNull(JSON.parse(response.data)[0].id)) {
                    Promise.all([
                        dispatch({
                            type: CHECK_TOKEN,
                            payload: new Date().getTime(),
                        })
                    ]);
                }
            }).catch(error => {
                return dispatch({
                    type: DOCUMENTOATENDIMENTO_ERROR,
                    payload: error
                });
            });
    };
}

export function clearReducer() {
    return {
        type: GET_DOCUMENTOATENDIMENTO,
        payload: null
    };
}